export default {
  '--bg_color_1': '#fff', // 页面背景颜色
  '--bg_color_2': '#FF8A38', // 小标签背景
  '--bg_color_3': '#fff', // 浮层选择框背景
  '--bg_color_4': '#fff', // 编辑框背景区块

  // '--text_main': '#0a8e41', // 默认绿色文字
  // '--text_main_hover': '#0db151', // 默认绿色文字hover
  '--text_main': '#00bc53', // 默认绿色文字
  '--text_main_hover': '#00a94b', // 默认绿色文字hover
  '--text_main_disable': '#10b75633', // 默认绿色文字置灰 0.2 透明度
  '--text_0': '#000', // 标题文字颜色 hover
  '--text_1': '#000', // 正文文字颜色 1
  '--text_2': '#333', // 辅助文字颜色 0.6
  '--text_3': '#999', // 辅助文字颜色 0.4
  '--text_4': '#0003', // 置灰文字颜色 0.2 透明度
  '--text_err': '#dd3232', // 强调错误提示文字
  '--text_s1': '#FD9E09', // 特殊强调提示文字1
  '--text_s2': '#CF2A40', // 特殊强调提示文字2

  '--btn_bg_main': '#10b756', // 绿色按钮填充色
  '--btn_bg_white': '#fff', // 白色按钮填充色
  '--btn_bg_main_hover': '#23c366', // 绿色按钮填充色hover态
  // '--btn_bd': '#94caa9', // 绿色按钮描边颜色
  '--btn_bd': '#00bc53', // 绿色按钮描边颜色
  '--btn_bd2': '#cae4d4', // 白色按钮边框颜色(我的软件)

  '--menu_main_bg': '#f4f4f4',
  '--menu_bg': '#f1f8f5', // 页面内菜单绿色背景颜色
  '--menu_bg_hover': '#deece5', // 页面内菜单绿色背景颜色hover
  '--menu_bg_active': '#00bc53', // 页面内菜单绿色背景颜色

  '--line_1': '#eee', // 分割线
  '--line_2': '#eee', // 编辑框边框、按钮边框
  '--line_3': '#eee', // 编辑框边框、按钮边框
  '--line_hover': '#386EFE', // 线hover
  '--line_err': '#dd3232', // 编辑框报错

  '--swiper-navigation-color': '#fff',
  '--swiper-preloader-color': '#fff',
  '--swiper-pagination-color': '#fff',
  '--swiper-theme-color': '#007aff',
  '--swiper-navigation-size': '44px',
  default: true,
};
